import React from 'react';
import hubLayout from 'styles/css/hubLayout.module.css';
import Modal from "react-modal";
import DaumPostcode from "react-daum-postcode";
import { useState, useEffect } from 'react';
import { User, UserInfo } from 'type/type';

interface InputFieldProps {
  label: string;
  type: string;
  placeholder: string;
  value: any;
  register: any;
  registerOptions: any;
  errors: any;
  readOnly?: boolean;
}

export const InputField: React.FC<InputFieldProps> = ({
  label,
  type,
  placeholder,
  value,
  register,
  registerOptions,
  errors,
  readOnly = false,
}) => {
  // console.log('errors && hubLayout.border_red', errors && hubLayout.border_red);
  return (
    <li className={`${hubLayout.inp_set} ${hubLayout.label_text}`}>
      <label className={`${registerOptions?.required ? hubLayout.imp : ''}`}>
        {label}
      </label>
      <input
        type={type}
        placeholder={placeholder}
        className={`${errors ? hubLayout.border_red : ''}`}
        value={value}
        readOnly={readOnly}
        {...register}
      />
      {errors ?
        (
          <span style={{ display: 'block', paddingLeft: '5px', color: 'red' }}>
            {errors.message}
          </span>
        )
      : label === 'Password' &&
        (
          <span style={{ display: 'block', paddingLeft: '10px'}}>
            <p>1. 비밀번호 자릿수 (최소 8자에서 16자까지)</p>
            <p>2. 최소 하나 이상의 영문자 (소문자 or 대문자)</p>
            <p>3. 최소 하나 이상의 숫자</p>
            <p>4. 최소 하나 이상의 특수문자 (!@#$%^&*?_.,)</p>
          </span>
        )
      }
    </li>
  );
};

interface InputFieldWrapProps {
  value: any;
  register: any;
  registerOptions: any;
  errors: any;
  readOnly?: boolean;
  showError?: boolean;
}

export const IdInputField: React.FC<InputFieldWrapProps> = ({
  value,
  register,
  registerOptions,
  errors,
  readOnly = false,
}) => {
  const key = 'id';
  registerOptions.name = key;
  return (
    <InputField
      label="ID"
      type="text"
      placeholder="ID"
      value={value[key]}
      register={register(key, registerOptions)}
      registerOptions={registerOptions}
      errors={errors[key]}
      readOnly={readOnly}
    />
  );
}

export const PwInputField: React.FC<InputFieldWrapProps> = ({
  value,
  register,
  registerOptions,
  errors,
  readOnly = false,
  showError = true,
}) => {
  const key = 'password';
  registerOptions.name = key;

  // 비밀번호 정규식
  const pattern = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*?_.,]).{8,16}$/g;
  registerOptions.pattern = pattern;

  // 에러 메시지를 원하는 형식으로 설정
  const errorMessageComponent = <span style={{ display: 'block', paddingLeft: '5px', color: 'red' }}>
    <p>1. 비밀번호 자릿수 (최소 8자에서 16자까지)</p>
    <p>2. 최소 하나 이상의 영문자 (소문자 or 대문자)</p>
    <p>3. 최소 하나 이상의 숫자</p>
    <p>4. 최소 하나 이상의 특수문자 (!@#$%^&*?_.,)</p>
  </span>;
  if (errors[key]) {
    errors[key].message = errorMessageComponent;
  }

  return (
    <InputField
      label="Password"
      type="password"
      placeholder="Password"
      value={value[key]}
      register={register(key, registerOptions)}
      registerOptions={registerOptions}
      errors={showError && errors[key]}
      readOnly={readOnly}
    />
  );
}

export const PwCheckInputField: React.FC<InputFieldWrapProps> = ({
  value,
  register,
  registerOptions,
  errors,
  readOnly = false,
}) => {
  const key = "passwordcheck";

  // `validate`를 사용하여 password와 일치하는지 검사
  const updatedRegisterOptions = {
    ...registerOptions,
    name: key,
    validate: (inputValue: string) =>
      inputValue === value.password || "비밀번호와 동일하게 입력해주세요.",
  };

  return (
    <InputField
      label="Password 확인"
      type="password"
      placeholder="Password 확인"
      value={value[key]}
      register={register(key, updatedRegisterOptions)}
      registerOptions={updatedRegisterOptions}
      errors={errors[key]}
      readOnly={readOnly}
    />
  );
};

export const NameInputField: React.FC<InputFieldWrapProps> = ({
  value,
  register,
  registerOptions,
  errors,
  readOnly = false,
}) => {
  const key = 'name';
  registerOptions.name = key;
  return (
    <InputField
      label="이름"
      type="text"
      placeholder="이름"
      value={value[key]}
      register={register(key, registerOptions)}
      registerOptions={registerOptions}
      errors={errors[key]}
      readOnly={readOnly}
    />
  );
}

export const MobileInputField: React.FC<InputFieldWrapProps> = ({
  value,
  register,
  registerOptions,
  errors,
  readOnly = false,
}) => {
  const key = 'mobile';
  registerOptions.name = key;
  return (
    <InputField
      label="연락처"
      type="text"
      placeholder="연락처"
      value={value[key]}
      register={register(key, registerOptions)}
      registerOptions={registerOptions}
      errors={errors[key]}
      readOnly={readOnly}
    />
  );
}

export const EmailInputField: React.FC<InputFieldWrapProps> = ({
  value,
  register,
  registerOptions,
  errors,
  readOnly = false,
}) => {
  const key = 'email';
  registerOptions.name = key;

  // 이메일 정규식
  const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  registerOptions.pattern = pattern;

  return (
    <InputField
      label="E-MAIL"
      type="email"
      placeholder="E-MAIL"
      value={value[key]}
      register={register(key, registerOptions)}
      registerOptions={registerOptions}
      errors={errors[key]}
      readOnly={readOnly}
    />
  );
}

export const AddrInputComponent = ({ name, title, user, handleChange, register, errors, setValue }: { name: string, title: string, user: User | UserInfo, handleChange: Function, register: Function, errors: any, setValue: Function }) => {
  // 다음주소 팝업창 theme
  const themeObj = {
    bgColor: "#FFFFFF", //바탕 배경색
    searchBgColor: "#FFFFFF", //검색창 배경색
    contentBgColor: "#FFFFFF", //본문 배경색(검색결과,결과없음,첫화면,검색서제스트)
    pageBgColor: "#162525", //페이지 배경색
    textColor: "#162525", //기본 글자색
    queryTextColor: "#162525", //검색창 글자색
    outlineColor: "#444444" //테두리
  };

  const [modalIsOpen, setmodalIsOpen] = useState(false);
  const openModal = () => {
    setmodalIsOpen(true);
    window.history.pushState({ modalIsOpen: true }, '');
  }
  const closeModal = () => {
    setmodalIsOpen(false);
    if (window.history.state?.modalIsOpen) {
      window.history.back(); // 히스토리 상태 복구
    }
  }

  const postCodeName = name.includes('company') ? 'company_post_code' : 'post_code';
  function openDaumPostcode(data: any) {
    const zoneCode:string = data.zonecode; // 우편번호
    const roadAddress:string = data.roadAddress; // 도로명주소
    handleChange({ target : { name : name, value : roadAddress } });
    handleChange({ target : { name : name.includes('company') ? 'company_post_code' : 'post_code', value : zoneCode } });
    // react-hook-form의 setValue 사용
    setValue(postCodeName, zoneCode, { shouldValidate: true }); // 유효성 검사 실행
    setValue(name, roadAddress, { shouldValidate: true });      // 유효성 검사 실행
    closeModal();
  }

  // 뒤로가기 이벤트 처리
  useEffect(() => {
    const handlePopState = () => {
      if (modalIsOpen) {
        closeModal();
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [modalIsOpen]);
  return (
    <>
      <li className={`${hubLayout.inp_set} ${hubLayout.label_text}`}>
        <label className={`${hubLayout.imp}`}>{title}</label>
        <input type="text" className={`${hubLayout.width_100} ${hubLayout.margin_right_10} ${errors.post_code && hubLayout.border_red}`} readOnly
            placeholder="우편번호" value={user.post_code || ""} 
          {...register(`post_code`, {
            required: true,
          })}
        />
        <button type="button" className={`${hubLayout.btn} ${hubLayout.width_100} ${hubLayout.medium} ${hubLayout.blue}`} onClick={openModal}>검색</button>
        
        <input type="text" placeholder="주소를 검색하세요." value={user.address || ""} className={`${hubLayout.margin_top_10} ${errors.address && hubLayout.border_red}`} readOnly
          {...register(`address`, {
            required: true,
          })}
        />
        <input name='address_detail' type="text" placeholder="상세주소 입력" value={user.address_detail || ""} className={`${hubLayout.margin_top_10} ${errors.address_detail && hubLayout.border_red}`}
          {...register(`address_detail`, {
            required: true,
            onChange: (e:any) => handleChange(e)
          })}
        />
      </li>
      {modalIsOpen &&
        <Modal
          isOpen={modalIsOpen} // 모달 열림/닫힘 상태
          onRequestClose={closeModal} // 모달 외부 클릭 시 닫힘
          ariaHideApp={false}
          style={{
            content: {
              width: '100%',
              top: "40%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              transform: "translate(-50%, -40%)",
            },
            overlay: {
              backgroundColor: "rgba(0,0,0,.7)",
              zIndex: "10000",
            },
          }}
        >
          <DaumPostcode
            onComplete={openDaumPostcode}
            style={themeObj}
          />
        </Modal>
      }
    </>
  );
}